<div class="col-12 col-am-12 col-md-10 col-lg-10 mx-auto">
    <div class="row mt10">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 pl4">
            <div class="col-12 col-sm-12 col-md-10 col-lg-9">
                <img class="moblogo" src="./assets/images/TL-Logo.svg">
                <div class="clear30"></div>
                <!-- <label class="semi-bold fs-36 red m-0 pl18">Travelance <span class="blue">Admin Portal</span> </label> -->
                <p class="fs-20 blue regular pl18 tabfs16 mobfs-18">To reset your password, enter your registered email address. You’ll receive an email with instructions to reset your password.</p>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mobpad7">
            <div class="circle text-left olnone cp semi-bold">
                <span class=""><img class="mt8 olnone mr-2 ml5" routerLink="/" src="./assets/images/forgetback.png"></span>
                &nbsp;Go Back to Login
                <!-- <img class="mt8 olnone" routerLink="/" src="./assets/images/backarrow.png"> -->
              </div>
              <div class="clear20"></div>
            <div class="col-12 col-sm-12 col-md-10 col-lg-9 pad32 ml60 box">
                <label class="fs-20 blue regular m-0 tabfs18">Forgot Password</label>
                <div class="clear10"></div>
                <label class="semi-bold black fs-16 tabfs14 mobfs-14">Enter your Registered Email Address</label>
                <div class="clear"></div>
                <input type="email" class="instyle regular w-100 olnone {{showemailErrorMsg?'borderb-red':''}}" placeholder="example@example.com" autocomplete="off" [(ngModel)]="email" (keyup)="ValidateEmail(email)" (input)="emailErrorMsg()">
                <span class="error-msg red fs-14" *ngIf="showemailErrorMsg">{{emailMsg}}</span>
                <div class="clear30"></div>
                <div class="clear10"></div>
                <!-- <div class="row">
                    <re-captcha  (resolved)="resolved($event)" siteKey="6LccUqkjAAAAAPbwke7-LqsDiGXbgUHeyb3cQkgZ"></re-captcha>                            
                </div> -->
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                    <button type="button" class="proceedbtn semi-bold olnone" (click)="resetLink()">Get Reset Link</button>
                </div>

            </div>
        </div>
    </div>
</div>




<!-- <p class="abc">login-page works!</p>
<p>
    <button type="button" class="btn  retrybtn fs-16 regular" (click)="goToHome()">
       CLICK</button>  
</p> -->